import { Box, Divider } from '@chakra-ui/react';
import { Accommodation } from '@data/models';
import { Day, Restriction } from '@calendar';
import { useStore } from '@data/other/withStore';
import Text from '@molecules/Text';
import { useMemo } from 'react';

interface Props {
  day?: Day;
}

const LIMIT = 5;

const RestrictionsTooltip = (props: Props) => {
  const {
    property: { accommodations },
  } = useStore();

  const restrictions = useMemo(
    () => props.day?.restrictions || [],
    [props.day]
  );

  const minlosAccommodations = useMemo(
    () => restrictions.filter((x) => x.type == 'minlos'),
    [props.day]
  );
  const maxlosAccommodations = useMemo(
    () => restrictions.filter((x) => x.type == 'maxlos'),
    [props.day]
  );

  const minvalue =
    minlosAccommodations.length > 0
      ? minlosAccommodations.reduce((previous, current) => {
          return current.value < previous.value ? current : previous;
        }).value
      : 1;

  const maxvalue =
    maxlosAccommodations.length > 0
      ? maxlosAccommodations.reduce((previous, current) => {
          return current.value > previous.value ? current : previous;
        }).value
      : 0;

  const minlos = minlosAccommodations.filter((x) => x.value == minvalue);
  const maxlos = maxlosAccommodations.filter((x) => x.value == maxvalue);

  function getRoomName(restriction: Restriction): string {
    return accommodations.getAccommodationName(
      restriction.room_id,
      restriction.package_id
    );
  }

  return (
    <Box minW="128px" px="16px" py="12px">
      {minlos.length > 0 && (
        <>
          <Text weight="600">{minvalue} Min Stay</Text>
          {minlos.map((restriction, index) =>
            index < LIMIT ? (
              <Text key={'min-' + index}>• {getRoomName(restriction)}</Text>
            ) : null
          )}
          {minlos.length > LIMIT && <Text>...</Text>}

          {maxlos.length > 0 && <Divider my="8px" />}
        </>
      )}

      {maxlos.length > 0 && (
        <>
          <Text weight="600">{maxvalue} Max Stay</Text>
          {maxlos.map((restriction, index) => (
            <Text key={'max-' + index}>• {getRoomName(restriction)}</Text>
          ))}
          {maxlos.length > LIMIT && <Text>...</Text>}
        </>
      )}
    </Box>
  );
};

export default RestrictionsTooltip;
